import { structuredDataContent } from '@/utils';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const JsonLD = ({ pageName }) => {
    // Get the specific structured data for this page
    const pageStructuredData = structuredDataContent[pageName];

    // Only render if this page has structured data
    if (!pageStructuredData) {
        return null;
    }

    return (
        <Helmet>
            <script type='application/ld+json'>{JSON.stringify(pageStructuredData)}</script>
        </Helmet>
    );
};

JsonLD.propTypes = {
    pageName: PropTypes.string.isRequired,
};

export default JsonLD;